"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicScript = void 0;
var react_1 = require("react");
var useDynamicScript = function (url) {
    var _a = __read((0, react_1.useState)(false), 2), ready = _a[0], setReady = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), failed = _b[0], setFailed = _b[1];
    (0, react_1.useEffect)(function () {
        if (!url)
            return;
        var element = document.createElement("script");
        element.src = url;
        element.type = "text/javascript";
        element.async = true;
        setReady(false);
        setFailed(false);
        element.onload = function () {
            console.log("Dynamic Script Loaded: ".concat(url));
            setReady(true);
        };
        element.onerror = function () {
            console.error("Dynamic Script Error: ".concat(url));
            setReady(false);
            setFailed(true);
        };
        document.head.appendChild(element);
        return function () {
            console.log("Dynamic Script Removed: ".concat(url));
            document.head.removeChild(element);
        };
    }, [url]);
    return {
        ready: ready,
        failed: failed,
    };
};
exports.useDynamicScript = useDynamicScript;
